import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const sendShopConfirmationEmail = async (shopData, userEmail) => {
  try {
    const queueEmail = httpsCallable(functions, "queueEmail");
    await queueEmail({
      type: "shop_confirmation",
      to: userEmail,
      shopData: {
        name: shopData.name,
        companyName: shopData.companyName,
        kvkNumber: shopData.kvkNumber,
        address: shopData.address,
        postalCode: shopData.postalCode,
        city: shopData.city,
        phone: shopData.phone,
        website: shopData.website,
        email: shopData.email,
      },
    });
    return true;
  } catch (error) {
    console.error("Error queuing shop confirmation email:", error);
    return false;
  }
};

export const sendWelcomeEmail = async (userEmail, firstName, lastName) => {
  try {
    const queueEmail = httpsCallable(functions, "queueEmail");
    await queueEmail({
      type: "welcome",
      to: userEmail,
      userData: {
        firstName,
        lastName,
        email: userEmail,
      },
    });
    return true;
  } catch (error) {
    console.error("Error queuing welcome email:", error);
    return false;
  }
};
